import { Button, Icon, Icons } from "@ir/ui";
import { memo } from "react";
import { PromotionSourceDocument } from "../../../../core/entities/promotion/PromotionDocument.types";

interface PromotionDocumentButtonProps {
  document: PromotionSourceDocument | null;
  isOpen: boolean;
  isDisabled?: boolean;
  onPress: () => void;
}

const PromotionDocumentButton = memo(({ document, isOpen, isDisabled, onPress }: PromotionDocumentButtonProps) => {
  if (!document) {
    return null;
  }

  return (
    <Button
      size="small"
      variant="outline"
      color="grey"
      className="py-1"
      isDisabled={isDisabled}
      onPress={onPress}
    >
      <Icon slot="start" name={Icons.File} size="small" />
      {isOpen ? "Hide Document" : "Source Document"}
    </Button>
  );
});

PromotionDocumentButton.displayName = "PromotionDocumentButton";

export default PromotionDocumentButton;
